import { FC } from 'react';
import React from 'react';

export const SQL: FC = () => {
    return (
        <div>
            <div> 
                <iframe 
                title="Slide" 
                src="https://docs.google.com/presentation/d/e/2PACX-1vQOgziTB3qchMrYDd1qw8JsWYypGETcB9TOnrcM2yCbU-_Iedb-XGbTzt6CiCsMqLc0TLom8t0VNkg_/embed?start=false&loop=false&delayms=60000" allowFullScreen 
                width="1200" height="675">

                 </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};
